//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from '../../components/helpers.js'
import { axiosGet } from '../../axios/axios.js'

export default {
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      loading: false,
      opened: false,
      info: {},

      header: '',
      text: null,
      deferred: false,
      onlyDeferred: false,
      time: null
      // timeShortcuts: [
      //   {
      //     text: 'Сегодня',
      //     onClick: () => {
      //       return this.getDayEnd()
      //     }
      //   },
      //   {
      //     text: 'Завтра',
      //     onClick: () => {
      //       return this.getDayEnd(1)
      //     }
      //   }
      // ]
    }
  },
  methods: {
    ask: function (callback, header, defaultRemark) {
      this.callback = callback
      if (header != null) {
        this.header = header
      }

      this.text = defaultRemark
      this.opened = true

      this.loading = true
      axiosGet({
        url: '/service/delta/request/getReworkInfo?id=' + this.request.requestId,
        onSuccess: (response) => {
          this.info = response.data.result

          if (this.info.hasWorksInProgress) {
            // this.deferred = true
            // this.onlyDeferred = true
            this.$q.notify({
              type: 'negative',
              message: 'Бригада уже приступила к работам по другому заданию',
              progress: true,
              timeout: 8000
            })

            this.close()
          }
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: 'Ошибка проверки статуса бригады',
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    confirm () {
      const millis = this.time != null ? this.time.getTime() : null
      if (this.deferred) {
        let error = null
        if (millis == null || millis < (new Date().getTime())) {
          error = 'Некорректное требуемое время завершения доработки'
        } else if (millis < (new Date().getTime()) + 600000) {
          // TODO uncomment
          // error = 'Требуемое время для завершения доработки должно быть не меньше 10 минут'
        }

        if (error) {
          this.$q.notify({
            type: 'negative',
            message: error,
            progress: true,
            timeout: 5000
          })

          return
        }
      }

      const value = {
        reworkReason: this.text ? this.text.slice() : '',
        deferred: !!this.deferred,
        deferralTime: this.time != null ? this.time.getTime() : null
      }

      this.close()
      !!this.callback && this.callback(value)
    },
    close () {
      this.opened = false
      this.clearValue()
    },
    clearValue () {
      this.info = {}
      this.text = ''
      this.deferred = false
      this.time = null
    },
    // getDayEnd (additionalDays = 0) {
    //   const date = new Date()
    //   date.setHours(0, 0, 0, 0)
    //   date.setDate(date.getDate() + 1 + additionalDays)
    //   return date
    // },
    formatTime (millis) {
      return formatTime(millis)
    }
  }
}
